export default "__VITE_ASSET__IU9Cg8kh__"